import {
  PlanBoxAmount,
  PlanBoxBilledAnnually,
  PlanBoxCurrency,
  PlanBoxLetsTalk,
  PlanBoxPeriod,
  PlanBoxPriceStyled,
  PlanBoxAnnuallyOrMonthlyText,
} from 'Features/pricing/components/PlanBox/PlanBox.styled'
import { getAmountWithCurrency } from 'Utils/currencyHelper'
import React from 'react'
import { Plan } from 'Features/pricing/types/Plan'
import { ProductTypes } from 'Types/ProductTypes'
import { PlansJson } from 'Types/Plan'
import { PlanTypes } from 'Types/PlansTypes'
import { CurrenciesTypes } from 'Types/Currencies'
import { useTranslation } from 'react-i18next'
import { usePaymentsFlowSplit } from 'Hooks/split/usePaymentsFlow'
import { useUserStore } from 'Stores/userStoreModuleFed'

type PlanBoxPriceProps = {
  numOfVisits: number
  product: ProductTypes
  plansDb: Array<Plan>
  plansJson: PlansJson
  planName: PlanTypes
  currency: CurrenciesTypes
}

export const PlanBoxPrice = ({
  numOfVisits,
  product,
  plansDb,
  plansJson,
  planName,
  currency,
}: PlanBoxPriceProps) => {
  const { t } = useTranslation('pricing')
  const isFeatureEnabled = usePaymentsFlowSplit()
  const installmentsPlan = '12_INSTALLMENTS'
  const { isInstallmentsSubscription } = useUserStore()

  const getPrice = () => {
    const amount = plansDb?.find((plan) => {
      return (
        plan.visitsAllowed === numOfVisits * 1000 &&
        plan.planType === planName &&
        plan.productType.toLowerCase() === product.toLowerCase() &&
        plan.currency === currency &&
        (isFeatureEnabled === installmentsPlan ? plan.billingCycleMonths === 1 : true)
      )
    })?.amount

    return amount ? (isFeatureEnabled === installmentsPlan ? amount : Math.ceil(amount / 12)) : 0
  }

  const planBoxBillingIntervalText: string = (() => {
    if (isFeatureEnabled === installmentsPlan && location.pathname === '/pricing') {
      return t('bundles.billed_annually_or_monthly')
    }
    if (isInstallmentsSubscription) {
      return t('bundles.billed_monthly')
    }
    return t('paid_marketing.billed_annually')
  })()

  return (
    <>
      {numOfVisits > plansJson.max_yearly_visits ? (
        <PlanBoxLetsTalk>{t('paid_marketing.custom_pricing')}</PlanBoxLetsTalk>
      ) : (
        <>
          <PlanBoxPriceStyled>
            <PlanBoxCurrency>{getAmountWithCurrency(currency, undefined)}</PlanBoxCurrency>
            <PlanBoxAmount>{getPrice()}</PlanBoxAmount>
            <PlanBoxPeriod>/m</PlanBoxPeriod>
          </PlanBoxPriceStyled>
          <PlanBoxBilledAnnually>
            <PlanBoxAnnuallyOrMonthlyText>
              {planBoxBillingIntervalText}
            </PlanBoxAnnuallyOrMonthlyText>
          </PlanBoxBilledAnnually>
        </>
      )}
    </>
  )
}
